export const Logo = ({ className = "text-2xl" }) => (
  <span
    className={`font-heading font-bold tracking-[-0.04em] leading-none select-none ${className}`}
    aria-label="OKKIO"
  >
    <span className="text-[#0F172A]">O</span>
    <span className="text-[#3157F6]">KK</span>
    <span className="text-[#0F172A]">IO</span>
  </span>
);

export default Logo;
